import { NgFor } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { Sidebar, SidebarModule } from 'primeng/sidebar';
import { StyleClassModule } from 'primeng/styleclass';
import { Menu } from '../api/menu';
import { LayoutService } from '../service/app.layout.service';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    SidebarModule,
    ButtonModule,
    RippleModule,
    AvatarModule,
    StyleClassModule,
    NgFor,
    SidebarItemComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  public layoutService = inject(LayoutService);

  @ViewChild('sidebarRef') sidebarRef!: Sidebar;

  isSidebarOpen: boolean = false;
  model: Menu[];

  constructor() {
    this.layoutService.isSidebarOpen$.subscribe((isOpen) => {
      this.isSidebarOpen = isOpen;
    });

    this.model = [
      {
        label: 'MENU_LATERAL.DASHBOARD',
        icon: 'pi pi-fw pi-home',
        routerLink: ['/dashboard'],
      },
      {
        label: 'MENU_LATERAL.LISTAR_PESSOAS',
        icon: 'pi pi-fw pi-users',
        routerLink: ['/listar-pessoas'],
      },

      {
        label: 'MENU_LATERAL.LISTAR_SISTEMAS',
        icon: 'pi pi-fw pi-cog',
        routerLink: ['/listar-sistemas'],
      },

      {
        label: 'MENU_LATERAL.LISTAR_PLANOS',
        icon: 'pi pi-fw pi-briefcase',
        routerLink: ['/listar-planos'],
      },
    ];

  }
}
